<template>
    <b-modal ref="warnModal" id="warn" size="sm" top>
        <p class="my-4">{{$t($store.state.modal.text)}}</p>
        <div slot="modal-footer">
            <b-button @click="triggerEvent()" variant="Primary">{{ $t('yes') }}</b-button>
            <b-button @click="$refs.warnModal.hide()" variant="Danger">{{ $t('cancel') }}</b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'warn',
    methods: {
        triggerEvent() {
            this.$eventHub.$emit(this.$store.state.modal.eventId, 1);
            this.$refs.warnModal.hide();
        }
    }
};
</script>

<style scoped>
</style>
<i18n src="../../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/modals/Warn.vue